import { fmtMoney } from './formatters';
import { parseOptionalLimit } from './resolvePlanCovenantLimits';

function limitAtMonth(byMonth, index, fallback) {
  if (byMonth?.[index] != null) {
    return byMonth[index];
  }
  return parseOptionalLimit(fallback);
}

export function computeFacilityLimitViolations({
  draw,
  endBal,
  maxExposure,
  maxMonthlyDraw,
  maxExposureByMonth = null,
  maxMonthlyDrawByMonth = null,
  maxDrawIncreasePct,
}) {

  const drawIncreaseLimit = parseOptionalLimit(maxDrawIncreasePct);

  const n = Math.max(draw?.length ?? 0, endBal?.length ?? 0);
  const drawViolations = new Array(n).fill(null);
  const endBalViolations = new Array(n).fill(null);

  for (let i = 0; i < n; i += 1) {
    const exposureLimit = limitAtMonth(maxExposureByMonth, i, maxExposure);
    const monthlyDrawLimit = limitAtMonth(maxMonthlyDrawByMonth, i, maxMonthlyDraw);

    if (exposureLimit != null && Number(endBal[i]) > exposureLimit) {
      endBalViolations[i] = {
        tooltip: `Max exposure ${fmtMoney(exposureLimit)}. Allowed ending balance: ${fmtMoney(exposureLimit)}.`,
      };
    }

    const tips = [];
    if (
      monthlyDrawLimit != null &&
      Number(draw[i]) > 0 &&
      Number(draw[i]) > monthlyDrawLimit
    ) {
      tips.push(`Max monthly draw ${fmtMoney(monthlyDrawLimit)}.`);
    }

    if (drawIncreaseLimit != null && i > 0) {
      const prevDraw = Number(draw[i - 1]);
      const currentDraw = Number(draw[i]);
      if (prevDraw > 0 && currentDraw > 0) {
        const allowedDraw = Math.round(prevDraw * (1 + drawIncreaseLimit / 100));
        if (currentDraw > allowedDraw) {
          tips.push(
            `Prior draw ${fmtMoney(prevDraw)}. Max increase ${drawIncreaseLimit}% → allowed draw ${fmtMoney(allowedDraw)}.`
          );
        }
      }
    }

    if (tips.length > 0) {
      drawViolations[i] = { tooltip: tips.join(' ') };
    }
  }

  return { drawViolations, endBalViolations };
}
